(function () {
  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getSelectedVariantId(formId) {
    var form = document.getElementById(formId);
    if (!form) return null;
    var select = form.querySelector('[data-product-select]');
    if (select && select.value) return select.value;
    var radios = form.querySelectorAll('input[name="id"]:checked');
    if (radios.length) return radios[0].value;
    var hidden = form.querySelector('input[name="id"]');
    if (hidden) return hidden.value;
    return null;
  }

  function findVariantById(variants, id) {
    id = parseInt(id, 10);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function optionValues(variant) {
    return [variant.option1, variant.option2, variant.option3];
  }

  function findFitTypeIndex(variants) {
    for (var i = 0; i < variants.length; i++) {
      var opts = optionValues(variants[i]);
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] === 'Custom Size') return j;
      }
    }
    return -1;
  }

  function findMatchingCustomVariant(variants, fitTypeIndex, referenceVariant) {
    if (fitTypeIndex === -1) return null;
    var refOpts = optionValues(referenceVariant);
    for (var i = 0; i < variants.length; i++) {
      var opts = optionValues(variants[i]);
      var matches = true;
      for (var j = 0; j < 3; j++) {
        if (j === fitTypeIndex) continue;
        if (opts[j] !== refOpts[j]) { matches = false; break; }
      }
      if (matches && opts[fitTypeIndex] === 'Custom Size') return variants[i];
    }
    return null;
  }

  function initBespokeBlock(block) {
    var uid = block.getAttribute('data-bespoke-uid');
    var modal = document.querySelector('.bespoke-modal[data-bespoke-uid="' + uid + '"]');
    if (!modal) return;

    var variantsScript = block.querySelector('[data-bespoke-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var fitTypeIndex = findFitTypeIndex(variants);

    var header = block.querySelector('[data-bespoke-header]');
    var openBtn = block.querySelector('[data-bespoke-open]');
    var openBtnDefaultLabel = openBtn.textContent;
    var closeBtn = modal.querySelector('[data-bespoke-close]');
    var submitBtn = modal.querySelector('[data-bespoke-submit]');
    var errorEl = modal.querySelector('[data-bespoke-error]');
    var priceEl = block.querySelector('[data-bespoke-price]');
    var summaryEl = block.querySelector('[data-bespoke-summary]');
    var footerEl = modal.querySelector('[data-bespoke-footer]');
    var selectedBadge = block.querySelector('[data-bespoke-selected-badge]');

    var formId = block.getAttribute('data-form-id');
    var form = document.getElementById(formId);

    function getCurrentVariant() {
      var selectedId = getSelectedVariantId(formId);
      return selectedId ? findVariantById(variants, selectedId) : null;
    }

    function isCustomSelected() {
      var current = getCurrentVariant();
      if (!current || fitTypeIndex === -1) return false;
      return optionValues(current)[fitTypeIndex] === 'Custom Size';
    }

    function updateSelectedState() {
      var selected = isCustomSelected();
      block.classList.toggle('is-selected', selected);
      if (selectedBadge) selectedBadge.hidden = !selected;
      openBtn.classList.toggle('is-selected', selected);
      openBtn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      openBtn.textContent = selected ? '✓ Custom Size Selected — Edit Details' : openBtnDefaultLabel;
    }

    function refreshPricePreview() {
      var current = getCurrentVariant();
      if (!current) return;
      var custom = findMatchingCustomVariant(variants, fitTypeIndex, current);
      if (priceEl) priceEl.textContent = formatMoney(custom ? custom.price : current.price);
    }

    function expandPanel() {
      if (block.classList.contains('is-active')) return;
      block.classList.add('is-active');
      header.setAttribute('aria-expanded', 'true');
    }

    function selectCustomSizeVariant() {
      if (isCustomSelected()) return;
      var radio = document.querySelector('.variant-input[data-value="Custom Size"] input[data-variant-input]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function toggle() {
      var active = block.classList.toggle('is-active');
      header.setAttribute('aria-expanded', active ? 'true' : 'false');
      refreshPricePreview();
      updateSelectedState();
    }

    header.addEventListener('click', toggle);
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    function openModal() {
      refreshPricePreview();
      updateSelectedState();
      expandPanel();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    var tabs = modal.querySelectorAll('[data-bespoke-tab]');
    var panes = modal.querySelectorAll('[data-bespoke-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabName = tab.getAttribute('data-bespoke-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panes.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        modal.querySelector('[data-bespoke-pane="' + tabName + '"]').classList.add('is-active');

        if (footerEl) {
          footerEl.style.display = (tabName === 'consult') ? 'none' : '';
        }
      });
    });

    var measureInputs = modal.querySelectorAll('[data-measure-target]');
    measureInputs.forEach(function (input) {
      var target = input.getAttribute('data-measure-target');
      var line = modal.querySelector('.bespoke-measure-line[data-measure="' + target + '"]');
      if (!line) return;
      input.addEventListener('focus', function () { line.classList.add('is-active'); });
      input.addEventListener('blur', function () { line.classList.remove('is-active'); });
    });

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    function activeTabName() {
      var activeTab = modal.querySelector('.bespoke-tab.is-active');
      return activeTab ? activeTab.getAttribute('data-bespoke-tab') : 'measure';
    }

    function collectProperties() {
      var mode = activeTabName();
      var props = {
        'Custom Size': 'Yes',
        'Estimated Ship Time': '2-3 weeks'
      };

      if (mode === 'consult') {
        props['Fit Method'] = 'Consultation Requested';
        return { properties: props };
      }

      props['Fit Method'] = mode === 'measure' ? 'Exact Measurements' : 'Standard Size + Adjustments';

      if (mode === 'measure') {
        var chest = modal.querySelector('[data-bespoke-field="chest"]').value;
        var shoulder = modal.querySelector('[data-bespoke-field="shoulder"]').value;
        var sleeve = modal.querySelector('[data-bespoke-field="sleeve"]').value;
        var length = modal.querySelector('[data-bespoke-field="length"]').value;
        var preference = modal.querySelector('[data-bespoke-field="preference"]').value;

        if (!chest || !shoulder || !sleeve || !length) {
          var missing = !chest ? 'chest' : (!shoulder ? 'shoulder' : (!sleeve ? 'sleeve' : 'length'));
          return { error: 'Please provide all four measurements, or switch to "Adjust My Usual Size."', field: missing };
        }

        props['Chest (in)'] = chest;
        props['Shoulder (in)'] = shoulder;
        props['Sleeve Length (in)'] = sleeve;
        props['Jacket Length (in)'] = length;
        props['Fit Preference'] = preference;
      } else {
        var refsize = modal.querySelector('[data-bespoke-field="refsize"]').value;
        var notes = modal.querySelector('[data-bespoke-field="notes"]').value;

        if (!notes || notes.trim().length < 3) {
          return { error: 'Please describe at least one adjustment, or switch to "Provide My Measurements."', field: 'notes' };
        }

        props['Reference Size'] = refsize;
        props['Adjustment Notes'] = notes.trim();
      }

      return { properties: props };
    }

    function clearHiddenProperties() {
      document.querySelectorAll('[data-bespoke-property="' + block.id + '"]').forEach(function (el) { el.remove(); });
    }

    function syncHiddenProperties(props) {
      clearHiddenProperties();
      if (!props || !form) return;
      Object.keys(props).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = props[key];
        input.setAttribute('form', formId);
        input.setAttribute('data-bespoke-property', block.id);
        document.body.appendChild(input);
      });
    }

    function renderSummary(props) {
      var lines = [];
      Object.keys(props).forEach(function (key) {
        if (key === 'Custom Size') return;
        lines.push('<strong>' + key + ':</strong> ' + props[key]);
      });
      summaryEl.innerHTML = '✓ Fit confirmed, ' + lines.join(' &middot; ');
      summaryEl.hidden = false;
    }

    submitBtn.addEventListener('click', function () {
      if (activeTabName() === 'consult') {
        closeModal();
        return;
      }

      clearError();
      var result = collectProperties();
      if (result.error) {
        showError(result.error);
        var fieldEl = modal.querySelector('[data-bespoke-field="' + result.field + '"]');
        if (fieldEl) fieldEl.focus();
        return;
      }

      selectCustomSizeVariant();
      syncHiddenProperties(result.properties);
      renderSummary(result.properties);
      updateSelectedState();
      closeModal();
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-variant-input]')) return;
      refreshPricePreview();
      updateSelectedState();
      if (isCustomSelected()) {
        expandPanel();
      } else {
        clearHiddenProperties();
        summaryEl.hidden = true;
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isCustomSelected()) return;
        var hasSaved = document.querySelector('[data-bespoke-property="' + block.id + '"]');
        if (!hasSaved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          expandPanel();
          openModal();
        }
      }, true);
    }

    refreshPricePreview();
    updateSelectedState();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bespoke]').forEach(initBespokeBlock);
  });
})();
